// extracted by mini-css-extract-plugin
export var cardIcon = "_8b-4";
export var checkboxCard = "_8b-0";
export var checkboxCardSelected = "_8b-3";
export var disabled = "_8b-1";
export var outerBorder = "_8b-2";
export var spacerMedium = "_8b-7";
export var spacerSmall = "_8b-6";
export var spacerXsmall = "_8b-5";